import React,{useEffect} from 'react';
import useStyles from './Styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Hidden from '@mui/material/Hidden';
import DownloadIcon from '@mui/icons-material/GetApp';
import logo_text from "./imgs/free/logotext.png";
import bigeye_square from "./imgs/free/bigeye_square_thumb.png";
import bigeye_round from "./imgs/free/bigeye_round_thumb.png";
import Title from './Title';

const LogoDownload = ()=> {
    const classes = useStyles();
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])    
    return (
        <div id="law" className={classes.root+" "+classes.policy}>
            <Paper className={classes.paper}>
                <Title text="ダウンロード：架空ストアのロゴ" icon="download"/>
				<div>
					サイトやSNS、まとめサービスなどで架空ストアのアイコン画像が必要でしたらこちらをご利用下さい。<br/>
					<ul style={{fontSize:'90%',backgroundColor:'#F5F5F5',padding:'1em',paddingLeft:'2em',lineHeight:'1.5em'}}>
						<li>サイズや形は自由に加工していただいて構いません。</li>
						<li>画像は予告なく変更する場合があります。</li>
						<li>架空ストアを紹介する目的以外では使用できません。</li>
					</ul>
				</div>
				<List>
					<ListItem>
						<ListItemIcon style={{marginRight:'2em'}}>
							<img src={bigeye_square} style={{width:'100px'}} alt="架空ストアロゴ（スクエア"/>
						</ListItemIcon>
						<ListItemText primary="架空ストアロゴ（スクエア）" secondary={(
							<>
							<div>1600px × 1600px</div>
							<Hidden smUp implementation="js">
								<Link href={`${process.env.PUBLIC_URL}/img/free/bigeye_square.png`} download><Button variant="outlined" color="primary" style={{marginTop:'0.5em'}}><DownloadIcon/>ダウンロード</Button></Link>
							</Hidden>
							</>
						)}/>
						<Hidden smDown implementation="js">
						<ListItemSecondaryAction>
							<Link href={`${process.env.PUBLIC_URL}/img/free/bigeye_square.png`} download><Button variant="outlined" color="primary"><DownloadIcon/>ダウンロード</Button></Link>
						</ListItemSecondaryAction>
						</Hidden>
					</ListItem>
					<ListItem>
						<ListItemIcon style={{marginRight:'2em'}}>
							<img src={bigeye_round} style={{width:'100px'}} alt="架空ストアロゴ（角丸）"/>
						</ListItemIcon>
						<ListItemText primary="架空ストアロゴ（角丸）" secondary={(
							<>
							<div>1600px × 1600px</div>
							<Hidden smUp implementation="js">
								<Link href={`${process.env.PUBLIC_URL}/img/free/bigeye_round.png`} download><Button variant="outlined" color="primary"><DownloadIcon/>ダウンロード</Button></Link>
							</Hidden>
							</>
						)}/>
						<Hidden smDown implementation="js">
						<ListItemSecondaryAction>
							<Link href={`${process.env.PUBLIC_URL}/img/free/bigeye_round.png`} download><Button variant="outlined" color="primary"><DownloadIcon/>ダウンロード</Button></Link>
						</ListItemSecondaryAction>
						</Hidden>
					</ListItem>
					<ListItem>
						<ListItemIcon style={{marginRight:'2em'}}>
							<img src={logo_text} style={{width:'100px'}} alt="架空ストアロゴ（テキスト）"/>
						</ListItemIcon>
						<ListItemText primary="架空ストアロゴ（テキスト）" secondary={(
							<>
							<div>400px × 60px</div>
							<Hidden smUp implementation="js">
								<Link href={`${process.env.PUBLIC_URL}/img/free/logotext.png`} download><Button variant="outlined" color="primary"><DownloadIcon/>ダウンロード</Button></Link>
							</Hidden>
							</>
						)}/>
						<Hidden smDown implementation="js">
						<ListItemSecondaryAction>
							<Link href={`${process.env.PUBLIC_URL}/img/free/logotext.png`} download><Button variant="outlined" color="primary"><DownloadIcon/>ダウンロード</Button></Link>
						</ListItemSecondaryAction>
						</Hidden>
					</ListItem>
				</List>

            </Paper>
        </div>
    )
}

export default LogoDownload;